// 把容器内部所有的内容区域统计到一个数组里
import { getLayoutSlot } from "../../../../lib/utils";
function getLayoutContents(layout) {
  let contents = [];
  contents.push(layout.children || []);
  contents.push(...Object.values(layout.slots || {}));
  contents.push(...Object.values(layout.scopedSlots || {}));
  contents = contents.filter(Array.isArray).filter(arr => arr.length > 0);
  return contents;
}
export function unPackAction(list, ctx) {
  const {
    layout,
    meta,
    replaceCompWith
  } = ctx;
  const unpackable = meta === null || meta === void 0 ? void 0 : meta.unpackable;
  if (!unpackable) return list;
  let content = null;
  // 先拿特定插槽名字
  if (typeof unpackable === 'string') {
    const temp = getLayoutSlot(layout, unpackable, false);
    if (Array.isArray(temp)) content = temp;
  }
  if (!content) {
    const contents = getLayoutContents(layout);
    const hasOnlyOneContent = contents.length === 1;
    if (!hasOnlyOneContent) return list;
    // 挑唯一的内容出来
    content = contents[0] || [];
  }
  if (!Array.isArray(content)) return list;
  // 直接把唯一的内容进行unpack
  list.push({
    title: '拆除',
    icon: 'fa fa-scissors',
    desc: '拆除容器保留内部的内容',
    place: ['actionBar', 'contextMenu', 'propPanel'],
    execute: () => {
      replaceCompWith(...content);
    }
  });
  return list;
}